import {
  Autorenew,
  CloudQueue,
  EventSeat,
  Group,
  ReportProblem,
  Restaurant,
  Star,
  WbSunny,
} from '@material-ui/icons';
import { TablePlanAssistantTemplateIcon } from 'types/tablePlanAssistant';

export type TablePlanAssistantQuickAction = {
  id: string;
  icon: React.ComponentType<any>;
  label: string;
  text: string;
};

export const TABLE_PLAN_ASSISTANT_TEMPLATE_ICONS: Record<
  TablePlanAssistantTemplateIcon,
  React.ComponentType<any>
> = {
  auto: Autorenew,
  cloud: CloudQueue,
  sunny: WbSunny,
  warning: ReportProblem,
  table: EventSeat,
  people: Group,
  restaurant: Restaurant,
  star: Star,
};

export const TABLE_PLAN_ASSISTANT_TEMPLATE_ICON_OPTIONS: {
  id: TablePlanAssistantTemplateIcon;
  label: string;
}[] = [
  { id: 'auto', label: 'Automatic' },
  { id: 'cloud', label: 'Cloud' },
  { id: 'sunny', label: 'Sun' },
  { id: 'warning', label: 'Warning' },
  { id: 'table', label: 'Table' },
  { id: 'people', label: 'Guests' },
  { id: 'restaurant', label: 'Restaurant' },
  { id: 'star', label: 'Star' },
];

export const getTablePlanAssistantTemplateIcon = (
  icon?: TablePlanAssistantTemplateIcon,
) => TABLE_PLAN_ASSISTANT_TEMPLATE_ICONS[icon ?? 'auto'];

export const BUILT_IN_QUICK_ACTIONS: TablePlanAssistantQuickAction[] = [
  {
    id: 'close-terrace',
    icon: CloudQueue,
    label: 'Terrasse schließen',
    text: 'Terrasse schließen und alle Reservierungen nach innen platzieren',
  },
  {
    id: 'open-terrace',
    icon: WbSunny,
    label: 'Terrasse öffnen',
    text: 'Terrasse öffnen und passende Reservierungen nach draußen verschieben',
  },
  {
    id: 'optimize',
    icon: Autorenew,
    label: 'Auslastung optimieren',
    text: 'Reservierungen für Auslastung optimieren',
  },
  {
    id: 'fix-warnings',
    icon: ReportProblem,
    label: 'Finde alle Warnungen und fixe diese',
    text: 'Finde alle Warnungen im aktuellen Reservierungstag und bereite passende Korrekturen als Entwurf vor. Prüfe insbesondere Reservierungen auf Tischen, die nicht ideal oder ungültig für diese Reservierung sind: Anlass, Bereich, Mindest- und Maximalgäste, Tischkombinationen, Überlappungen und Tischverfügbarkeit. Prüfe außerdem blockierte Reservierungen oder blockierte Tische, Reservierungen ohne zugewiesene Tische, ungültige Bereiche, fehlende Platzierungen und alle weiteren Auffälligkeiten, die im Tischplan problematisch sind. Fixe nur Warnungen, bei denen du eine sinnvolle und sichere Verbesserung findest. Wenn eine Änderung ausdrücklich bestätigt werden muss, zum Beispiel Blockieren oder Entblocken, dann bereite sie als bestätigungspflichtige Änderung vor und erkläre kurz warum.',
  },
];
